// Utility to handle Google Maps API loading
export const isGoogleMapsLoaded = () => {
  return typeof window !== 'undefined' && 
         window.google && 
         window.google.maps && 
         window.google.maps.places;
};

export const waitForGoogleMaps = (timeout = 10000) => {
  return new Promise((resolve, reject) => {
    if (isGoogleMapsLoaded()) {
      resolve(true);
      return;
    }

    const checkInterval = 100;
    let elapsed = 0;
    
    const interval = setInterval(() => {
      elapsed += checkInterval;
      
      if (isGoogleMapsLoaded()) {
        clearInterval(interval);
        resolve(true);
      } else if (elapsed >= timeout) {
        clearInterval(interval);
        reject(new Error('Google Maps API failed to load within timeout'));
      }
    }, checkInterval);
  });
};

export const loadGoogleMapsScript = (apiKey, libraries = ['places']) => {
  return new Promise((resolve, reject) => {
    if (isGoogleMapsLoaded()) {
      resolve(true);
      return;
    }

    // Check if script is already being loaded
    const existingScript = document.querySelector('script[src*="maps.googleapis.com"]');
    if (existingScript) {
      waitForGoogleMaps().then(resolve).catch(reject);
      return;
    }

    const script = document.createElement('script');
    script.src = `https://maps.googleapis.com/maps/api/js?key=${apiKey}&libraries=${libraries.join(',')}&callback=initGoogleMaps`;
    script.async = true;
    script.defer = true;

    // Create global callback
    window.initGoogleMaps = () => {
      delete window.initGoogleMaps;
      resolve(true);
    };

    script.onerror = () => {
      delete window.initGoogleMaps;
      reject(new Error('Failed to load Google Maps script'));
    };

    document.head.appendChild(script);
  });
};
